import React from 'react';

export default function IconEIpo() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2545_9755)">
        <g clipPath="url(#clip1_2545_9755)">
          <path
            d="M1.40283 1.46484H14.5973"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.8478 11.8121L8.00054 14.6176L2.15332 11.8121V1.46484H13.8478V11.8121Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.51904 4.92383V8.45855"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.4436 4.92383V8.45855"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.08249 4.92383H6.4436V6.69466H8.08249V4.92383Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.5066 5.74327C11.5066 5.29071 11.1397 4.92383 10.6871 4.92383C10.2346 4.92383 9.86768 5.29071 9.86768 5.74327V7.51411C9.86768 7.96667 10.2346 8.33355 10.6871 8.33355C11.1397 8.33355 11.5066 7.96667 11.5066 7.51411V5.74327Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.51904 10.2246L11.6065 10.2246"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2545_9755">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_2545_9755">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
